module.exports = __webpack_public_path__ + "static/media/uy.82e79aac.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/uy.svg
// module id = 2238
// module chunks = 0